import { render, staticRenderFns } from "./AvisoUploadDocumentos.vue?vue&type=template&id=1cf8665d&scoped=true"
import script from "./AvisoUploadDocumentos.vue?vue&type=script&lang=js"
export * from "./AvisoUploadDocumentos.vue?vue&type=script&lang=js"
import style0 from "./AvisoUploadDocumentos.vue?vue&type=style&index=0&id=1cf8665d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf8665d",
  null
  
)

export default component.exports